import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TsType, TS_SCREEN } from '../types/common/CommonType';

// 画面遷移状態管理
const slice = createSlice({
    name: 'ScreenTransition',
    initialState: TS_SCREEN.EST,
    reducers: {
        // 全置換
        setState: (_state, action: PayloadAction<TsType>) => action.payload,
        // 初期化
        initState: () => undefined,
    },
});

export const { actions, reducer } = slice;
export const { setState, initState } = actions;
